import { connect } from 'react-redux';

import BuildPageChartContainer from './/BuildPageChartContainer.jsx';
import { getSourceAttributeCountsMetricsInfo } from './../reducers';

export const mapStateToProps = (state) => {
  const metricsInfo = getSourceAttributeCountsMetricsInfo(state);
  metricsInfo.metrics = metricsInfo.metrics.map(m => m.sourceAttributeCountDiff);

  return {
    title: 'Source Attribute Count Difference',
    metricsInfo
  };
};

export default connect(
  mapStateToProps
)(BuildPageChartContainer);


// WEBPACK FOOTER //
// src/Containers/SourceAttributeCountChartContainer.jsx